import { render, staticRenderFns } from "./update-business-partner-form.vue?vue&type=template&id=7e85a364&"
import script from "./update-business-partner-form.vue?vue&type=script&lang=js&"
export * from "./update-business-partner-form.vue?vue&type=script&lang=js&"
import style0 from "./update-business-partner-form.vue?vue&type=style&index=0&id=7e85a364&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports